module.exports = __webpack_public_path__ + "img/battery_4disable.98fb0be7.png";